import SmallCross from 'components/Icons/SmallCross';
import React from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import './modals.css';

interface Props extends WithAppStoreProps {
  text: string;
  showCloseCross?: boolean;
  onClose?: () => void;
}

class ModalStdHeader extends React.Component<Props> {
  static defaultProps = {
    showCloseCross: true,
  };

  handleCancelClick = (): void => {
    this.props.actions.clearAllModals();

    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render(): React.ReactNode {
    const { text, showCloseCross } = this.props;
    return (
      <div
        className="row hs3 justify-between items-center px3 shrink-0 modal__header"
        style={{ backgroundColor: 'var(--light-grey-2)' }}
      >
        <span className="font-size-4 color-gray-7 medium">{text}</span>
        {showCloseCross ? (
          <span
            id="x-btn"
            className="flex-center line-height-1 font-size-9 cursor-pointer"
            onClick={this.handleCancelClick}
          >
            <SmallCross width="8px" height="8px" />
          </span>
        ) : null}
      </div>
    );
  }
}

export default withAppStore<Props>(ModalStdHeader);
